// import { Report55Component } from "../../../components/SupportSystem/Reports/Report55Component";
import { ListReportSupportComponent } from "../../../components/SupportSystem/Reports/ListReportSupportComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
// import { NavbarComponent } from "../../../components/share/NavbarComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function ListReportSupportContainer() {
    const titleName = "รายงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem  />
            <HeadTitle title={titleName} />
            <ListReportSupportComponent/>
            <Footer />
        </div>   
        // 
    )
    
}